import { SuperModel } from './super-model.model';

export class User extends SuperModel {
  family_name: string;
  given_name: string;
  name: string;
  email: string;
  constructor(data = {}) {
    super(data);
  }
  get serialised() {
    return {
      id: this.id,
      email: this.email,
    };
  }

  get canViewLogs() {
    return true;
  }
}
